;
/*!
 * subitotexto.loadmorecomments.js
 */
SubitoTexto.loadMoreComments = {
	init                       : function () {
		var $ = jqPla,
			_this = SubitoTexto.loadMoreComments;

		if ( typeof CONFIG == 'undefined' || CONFIG.load_more_comments_url == 'undefined' ) {
			console.error( '[SubitoTexto.loadMoreComments] Need the URL to load more' );
			return;
		}

		// Detecting presence / need with this selector
		_this.$moreCommentsContainer = $( '.comments-more' );
		if ( _this.$moreCommentsContainer.length < 1 ) {
			// Nothing to do on this page
			return;
		}


		// Moving on with vars and initial methods
		_this.$originalComments = $( '#comment_latest' ).find( '.comment' );
		_this.$btnLoadMore = $( '.btn-load-more' );
		_this.hasMoreComments = _this.$moreCommentsContainer.data( 'has-more-comments' );
		_this.commentsType = _this.$moreCommentsContainer.data( 'comments-mode' );
		_this.parentId = _this.$moreCommentsContainer.data( 'parent-id' );
		_this.hasMoreCommentsBtnActive = _this.hasMoreComments && _this.hasMoreComments == true;

		_this.currPage = 1;
		_this.currAuthorFilter = false;
		_this.numPostsOnInitialPage = _this.$originalComments.length;
		_this.commentsPerPage = _this.$moreCommentsContainer.data( 'comments-per-page' ) ? _this.$moreCommentsContainer.data( 'comments-per-page' ) : 10;


		// No use in setting everything up if there aren't any more posts
		if ( _this.hasMoreComments == false ) {
			_this.deactivateMoreFunctionality();
			return;
		}


		_this.bindEvents();


	},
	bindEvents                 : function () {
		var $ = jqPla,
			_this = SubitoTexto.loadMoreComments;

		_this.activateMoreFunctionality();


	},
	activateMoreFunctionality  : function () {
		var $ = jqPla,
			_this = SubitoTexto.loadMoreComments;

		_this.$btnLoadMore.show();
		_this.$btnLoadMore.on( 'click.btnLoadMore', function ( e ) {
			_this.ajaxGetMoreComments();
		} );

		_this.hasMoreCommentsBtnActive = true;

	},
	deactivateMoreFunctionality: function () {
		var $ = jqPla,
			_this = SubitoTexto.loadMoreComments;

		_this.$btnLoadMore.off( 'click.btnLoadMore' );

		_this.$btnLoadMore.hide();

		_this.hasMoreCommentsBtnActive = false;
	},

	appendComments     : function ( arrComments ) {
		var $ = jqPla,
			_this = SubitoTexto.loadMoreComments;

		var numComments = arrComments.length

		if ( numComments < 1 ) {
			// weird... we should have at least one to work with
			return;
		}

		var htmlToAppend = '';

		$.each( arrComments, function ( i, el ) {
			htmlToAppend += _this.commentTemplate( el );
		} );


		var $appended = $( htmlToAppend ).appendTo( _this.$moreCommentsContainer );
		_this.replaceEmojisClientSide( $appended );

		return $appended;
	},
	ajaxGetMoreComments: function () {
		var $ = jqPla,
			_this = SubitoTexto.loadMoreComments;

		var dataRequest = {
			action         : 'load_more_comments',
			currCommentsNum: _this.numPostsOnInitialPage + _this.$moreCommentsContainer.find( '.comment' ).length,
			currPage       : _this.currPage,
			commentsPerPage: _this.commentsPerPage,
			type           : _this.commentsType,
			parentId       : _this.parentId
		};


		_this.$moreCommentsContainer.attr( 'aria-busy', true );

		$.ajax( {
			url     : CONFIG.load_more_comments_url,
			data    : dataRequest,
			dataType: 'json',
			type    : 'post',
		} )
			.done( function ( _data ) {


				if ( typeof _data.success != 'undefined' && _data.success == 1
					&& typeof _data.data != 'undefined'
					&& typeof  _data.data.comments != 'undefined' && _data.data.comments.length > 0 ) {


					var $appendedComments = _this.appendComments( _data.data.comments );
					_this.currPage = _data.data.iNewCurrPage;
					_this.hasMoreComments = _data.data.isLastPage != true;

					_this.$moreCommentsContainer.removeAttr( 'aria-busy' );



					if ( !_this.hasMoreComments ) {
						_this.deactivateMoreFunctionality();
					} else {

						// No use in re-binding if it's already bind'ed
						if ( !_this.hasMoreCommentsBtnActive ) {
							_this.activateMoreFunctionality();
						}
					}

					//console.log('APPENDED', $appendedComments.eq(0));

					PLA.UTILS.scrollTop.scrollTo($appendedComments.eq(0), -10);
					$appendedComments.eq(0).focus();

				} else {
					console.table( _data.errors );
				}
			} );


	},


	commentTemplate: function ( comment ) {
		return '  <article class="comment">' +
			'<h3 class="comment-name" >' + comment.author + '</h3>' +
			'<div class="comment-content">' + comment.comment + '</div>' +
			'</article>';
	},


	replaceEmojisClientSide: function ( $selector ) {
		var $ = jqPla,
			_this = SubitoTexto.loadMoreComments;


		if ( $selector.length > 0 ) {

			$selector.find( 'h3, div' ).each( function ( i, el ) {
				var $this = $( this ),
					htmlOriginal = $this.html(),
					convertedHtml = SubitoTexto.emoji.convertFromDb( htmlOriginal );


				// No use in doing this if there are no emoji
				if ( htmlOriginal != convertedHtml ) {
					$this.html( convertedHtml );
				}
			} );
		}
	}


};
